var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.34315 3.34315 2 5 2H7C8.65685 2 10 3.34315 10 5H14C14 3.34315 15.3431 2 17 2H19C20.6569 2 22 3.34315 22 5V7C22 8.65685 20.6569 10 19 10H17C15.3431 10 14 8.65685 14 7H10C10 8.65685 8.65685 10 7 10V14C7 15.6569 8.34315 17 10 17H14C14 15.3431 15.3431 14 17 14H19C20.6569 14 22 15.3431 22 17V19C22 20.6569 20.6569 22 19 22H17C15.3431 22 14 20.6569 14 19H10C7.23858 19 5 16.7614 5 14V10C3.34315 10 2 8.65685 2 7V5ZM5 4C4.44772 4 4 4.44772 4 5V7C4 7.55228 4.44772 8 5 8H7C7.55228 8 8 7.55228 8 7V5C8 4.44772 7.55228 4 7 4H5ZM17 4C16.4477 4 16 4.44772 16 5V7C16 7.55228 16.4477 8 17 8H19C19.5523 8 20 7.55228 20 7V5C20 4.44772 19.5523 4 19 4H17ZM16 17C16 16.4477 16.4477 16 17 16H19C19.5523 16 20 16.4477 20 17V19C20 19.5523 19.5523 20 19 20H17C16.4477 20 16 19.5523 16 19V17Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceTab);
export default __webpack_public_path__ + "static/media/balance-tab.81e62c78.svg";
export { ForwardRef as ReactComponent };